/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ea-danger-alert[_ngcontent-%COMP%]{margin-top:10px}"];
export { styles as styles };
